const getAutomationItemThreadId = ({ item, fallbackToId = false }) => {
  return String(item?.threadId || (fallbackToId ? item?.id : '') || '').trim() || null;
};

export default getAutomationItemThreadId;
